// extracted by mini-css-extract-plugin
export default {"padding_box":"AttachmentList_padding_box__3k0wn","left_titel":"AttachmentList_left_titel__JuPm1","right_progrop":"AttachmentList_right_progrop__Zf-39"};